import { animate } from 'framer-motion';
import { useEffect, useRef } from 'react';
import { useIO } from '../../hooks/use-io';

export const Counter = ({ from, to, width, duration = 1, delay = 0 }) => {
  const nodeRef = useRef();
  const entry = useIO(nodeRef, true);
  const isVisible = !!entry?.isIntersecting;

  useEffect(() => {
    const node = nodeRef.current;

    let controls = { stop: () => {} };

    if (isVisible) {
      controls = animate(from, to, {
        duration,
        delay,
        onUpdate(value) {
          node.textContent = value.toLocaleString('en-US').replace(/\..*/, '');
        },
      });
    }

    return () => controls.stop();
  }, [from, to, isVisible]);

  return (
    <span ref={nodeRef} className="counter" style={{ width }}>
      {from.toLocaleString('en-US')}
    </span>
  );
};
